import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import '../../css/ServiceCompanyRegistration.css';

function ServiceCompanyRegistration() {
    const navigate = useNavigate();
    const [formCompleted, setFormCompleted] = useState(false);
    const [companyName, setCompanyName] = useState('');
    const [contactName, setContactName] = useState('');
    const [email, setEmail] = useState('');
    const [phoneNumber, setPhoneNumber] = useState('');
    const [trades, setTrades] = useState([]);
    const [id, setId] = useState('');
    const [errorMessage, setErrorMessage] = useState('');

    useEffect(() => {
        const queryParams = new URLSearchParams(window.location.search);
        const tradesFromUrl = queryParams.get('trades')?.split(',').filter(Boolean) || [];
        setTrades(tradesFromUrl);
        const linkHashFromUrl = queryParams.get('id') || "";
        if (linkHashFromUrl) {
            axios.get(`/api/service_providers/${linkHashFromUrl}`)
                .then(response => {
                    if (response.status === 200) {
                        const company = response.data;
                        setId(linkHashFromUrl);
                        setCompanyName(company.name);
                        setContactName(company.contact_name);
                        setEmail(company.email);
                        setPhoneNumber(company.phone);
                    } else {
                        throw new Error('Unexpected response status');
                    }
                })
        }
    }, []);

    useEffect(() => {
        checkFormCompletion();
    }, [companyName, contactName, email, phoneNumber]);

    const validateEmail = (email) => {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailRegex.test(email);
    };

    const handleSubmit = async () => {
        if (!validateEmail(email)) {
            setErrorMessage("Please enter a valid email address.");
        } else {
            setErrorMessage("");
            try {
                const data = {
                    id,
                    companyName,
                    contactName,
                    email,
                    phoneNumber,
                    trades
                };
                const response = await axios.post('/api/service_provider_form', data)

                navigate('/service-company-create-password?cp=' + response.data.create_password_hash);
            } catch (error) {
                setErrorMessage("There was an error submitting the form. Please try again.");
            }
        }
    };

    const checkFormCompletion = () => {
        if (companyName && contactName && email && phoneNumber) {
            setFormCompleted(true);
        } else {
            setFormCompleted(false);
        }
    };

    const handleCompanyNameChange = (e) => {
        setCompanyName(e.target.value);
        checkFormCompletion();
    };

    const handleContactNameChange = (e) => {
        setContactName(e.target.value);
        checkFormCompletion();
    };

    const handleEmailChange = (e) => {
        setEmail(e.target.value);
        checkFormCompletion();
    };

    const handlePhoneNumberChange = (e) => {
        setPhoneNumber(e.target.value);
        checkFormCompletion();
    };

    return (
        <div className="service-company-registration-container">
            <div className="service-company-registration-wrap">
                <div className="service-company-registration-title">Service Company Registration</div>
                <div className="service-company-registration-body">
                    Join our exclusive directory to connect with Realtors, and grow your business
                </div>
                <div className="service-company-registration-form-wrap">
                    <div className="service-company-registration-form-row">
                        <div className="service-company-registration-form-field-wrap">
                            <div className="service-company-registration-form-field-label">
                                Company Name <span className="red">*</span>
                            </div>
                            <input
                                type="text"
                                className="service-company-registration-form-field-input"
                                placeholder="Company name"
                                value={companyName}
                                onChange={handleCompanyNameChange}
                            />
                        </div>
                        <div className="service-company-registration-form-field-wrap">
                            <div className="service-company-registration-form-field-label">
                                Contact Name <span className="red">*</span>
                            </div>
                            <input
                                type="text"
                                className="service-company-registration-form-field-input"
                                placeholder="First / Last name"
                                value={contactName}
                                onChange={handleContactNameChange}
                            />
                        </div>
                    </div>
                    <div className="service-company-registration-form-row">
                        <div className="service-company-registration-form-field-wrap">
                            <div className="service-company-registration-form-field-label">
                                Email <span className="red">*</span>
                            </div>
                            <input
                                type="text"
                                className="service-company-registration-form-field-input"
                                placeholder="email@company.com"
                                value={email}
                                onChange={handleEmailChange}
                            />
                        </div>
                        <div className="service-company-registration-form-field-wrap">
                            <div className="service-company-registration-form-field-label">
                                Phone Number <span className="red">*</span>
                            </div>
                            <input
                                type="text"
                                className="service-company-registration-form-field-input"
                                placeholder="000-000-0000"
                                value={phoneNumber}
                                onChange={handlePhoneNumberChange}
                            />
                        </div>
                    </div>
                </div>
                <div className="service-company-registration-form-required-info">
                    <span className="red">*</span> Required
                </div>
                {errorMessage && <div className="service-company-registration-form-submit-error-message">{errorMessage}</div>}
                <div className="service-company-registration-form-submit-button-wrap">
                    <div
                        className={`service-company-registration-form-submit-button ${formCompleted ? 'action' : ''}`}
                        onClick={handleSubmit}
                    >
                        Join Now &gt;&gt;
                    </div>
                </div>
            </div>
        </div>
    );
}

export default ServiceCompanyRegistration;
